module.exports = __webpack_public_path__ + "static/media/navigation-background.120d9c00.svg";